import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative flex-1 w-full h-full flex flex-col bg-transparent overflow-hidden" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 p-3 bg-destructive/10 border-t border-destructive/20 text-destructive text-sm flex items-start gap-2 max-h-[60%] overflow-auto backdrop-blur-sm shadow-[0_-10px_15px_-3px_rgba(0,0,0,0.1)] z-10"
}
const _hoisted_4 = { class: "whitespace-pre-wrap font-sans text-xs flex-1 leading-tight" }

import { ref, watch, onMounted } from 'vue'
import { AlertCircle } from 'lucide-vue-next'
import mermaid from 'mermaid'
import { torcazaMermaidConfig } from '@/config/mermaidTheme'


export default /*@__PURE__*/_defineComponent({
  __name: 'MermaidCodeEditor',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const error = ref('')
const internalCode = ref(props.modelValue)

let validateTimeout: ReturnType<typeof setTimeout> | null = null

const validateCode = async (code: string) => {
  if (!code.trim()) {
    error.value = ''
    return
  }
  try {
    error.value = ''
    // Extraer código puro si tiene bloques markdown
    let rawCode = code
    const match = code.match(/```mermaid\n([\s\S]*?)```/)
    if (match) {
      rawCode = match[1]
    } else {
      rawCode = code.replace(/```mermaid\n?/g, '').replace(/```\n?/g, '')
    }
    
    // Mermaid necesita inicializarse antes del parse
    mermaid.initialize(torcazaMermaidConfig)
    await mermaid.parse(rawCode)
  } catch (e: any) {
    error.value = e.message || 'Sintaxis de Mermaid inválida'
  }
}

onMounted(() => {
  validateCode(internalCode.value)
})

watch(() => props.modelValue, (newVal) => {
  if (internalCode.value !== newVal) {
    internalCode.value = newVal
    validateCode(newVal)
  }
})

const onInput = (e: Event) => {
  const target = e.target as HTMLTextAreaElement
  internalCode.value = target.value
  emit('update:modelValue', target.value)
  
  if (validateTimeout) clearTimeout(validateTimeout)
  validateTimeout = setTimeout(() => {
    validateCode(target.value)
  }, 400)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("textarea", {
      value: internalCode.value,
      onInput: onInput,
      class: "flex-1 w-full h-full p-4 resize-none outline-none font-mono text-xs text-foreground bg-transparent focus:ring-2 focus:ring-inset focus:ring-primary",
      spellcheck: "false",
      placeholder: "Escribe tu código Mermaid aquí..."
    }, null, 40, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "enter-from-class": "translate-y-full opacity-0",
      "enter-to-class": "translate-y-0 opacity-100",
      "leave-active-class": "transition-all duration-200 ease-in",
      "leave-from-class": "translate-y-0 opacity-100",
      "leave-to-class": "translate-y-full opacity-0"
    }, {
      default: _withCtx(() => [
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(AlertCircle), { class: "w-4 h-4 mt-0.5 shrink-0" }),
              _createElementVNode("pre", _hoisted_4, _toDisplayString(error.value), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})